import { StyleSheet, View } from 'react-native';

import { formatCentsToDollars } from '@fhs/menu/src/utils';
import { Button, IconRedeem, Pressable, Text, XStack, tokens } from '@fhs/ui';

import { StepCheckBalanceProps } from './types';

export const StepCheckBalance = ({
  cardId,
  balance,
  onChangePress,
  onAddToYourAccountPress,
}: StepCheckBalanceProps) => {
  return (
    <>
      <XStack style={styles.cardIdContainer}>
        <XStack style={styles.cardLeftSideWrapper}>
          <View style={styles.iconContainer}>
            <IconRedeem size={24} color={tokens.colors.$houseDark} />
          </View>
          <Text># {cardId}</Text>
        </XStack>
        <Pressable onPress={onChangePress}>
          <Text style={styles.changeText}>Change</Text>
        </Pressable>
      </XStack>
      <XStack style={styles.newBalanceRow}>
        <Text weight="semibold" style={styles.newBalanceText}>
          Gift Card Balance:
        </Text>
        <Text weight="semibold" style={styles.newBalanceText}>
          {formatCentsToDollars(balance)}
        </Text>
      </XStack>
      <Button style={styles.saveButton} size="lg" onPress={onAddToYourAccountPress}>
        <Button.Text>Add To Your Account</Button.Text>
      </Button>
    </>
  );
};

const styles = StyleSheet.create({
  cardIdContainer: {
    padding: 16,
    gap: 16,
    marginBottom: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardLeftSideWrapper: {
    alignItems: 'center',
    gap: 16,
  },
  iconContainer: {
    borderRadius: 100,
    backgroundColor: tokens.colors.$blackOpacity04,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  balanceWrapper: {
    marginTop: 16,
    borderBottomWidth: 1,
    paddingBottom: 16,
    borderColor: tokens.colors.$blackOpacity04,
  },
  balanceRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  balanceText: {
    fontSize: 12,
    lineHeight: 16.8,
  },
  newBalanceRow: {
    marginTop: 16,
    marginBottom: 4,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  newBalanceText: {
    fontSize: 14,
    lineHeight: 19.6,
  },
  changeText: {
    textDecorationLine: 'underline',
    fontSize: 12,
  },
  saveButton: {
    marginTop: 16,
  },
});
